import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SwitchListItem from '../../../../../list-items/SwitchListItem/SwitchListItem';

const VisualizerSmoothListItem = (props) => {
    const { visualizerSmoothed, updateVisualizerSettings } = props;
    const onSmoothChange = (event) => updateVisualizerSettings({ smoothed: event.target.checked });
    
    return (
        <SwitchListItem
            text='Smooth'
            checked={visualizerSmoothed}
            onChange={onSmoothChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { smoothed: visualizerSmoothed } = state.createPreview.present.videoSettings.visualizer;
    return { visualizerSmoothed };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerSmoothListItem);